module.exports = __webpack_public_path__ + "img/colgador.5e1a4cf1.svg";